import React from 'react';
import ClassSelectPage from './ClassSelectPage';

const ClassTodoSelectPage = () => {
  return <ClassSelectPage type="todos" />;
};

export default ClassTodoSelectPage;
